import { render, staticRenderFns } from "./NInputView.vue?vue&type=template&id=6f152a62&scoped=true&"
import script from "./NInputView.vue?vue&type=script&lang=js&"
export * from "./NInputView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f152a62",
  null
  
)

export default component.exports